import React from 'react';
import { CountdownBanner } from './components/CountdownBanner';
import { Hero } from './components/Hero';
import { CTA1 } from './components/CTA1';
import { Testimonials1 } from './components/Testimonials1';
import { PainSection } from './components/PainSection';
import { ProductReveal } from './components/ProductReveal';
import { TomosSection } from './components/TomosSection';
import { CTA2 } from './components/CTA2';
import { BonosSection } from './components/BonosSection';
import { TestimonialsGrid } from './components/TestimonialsGrid';
import { CTA3 } from './components/CTA3';
import { ComparisonTable } from './components/ComparisonTable';
import { Testimonials3 } from './components/Testimonials3';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostTable } from './components/CostTable';
import { CTA4 } from './components/CTA4';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-sage/30 selection:text-forest flex flex-col" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <CountdownBanner data-id="element-2" />
      <PurchaseNotification data-id="element-3" />

      <main className="flex-grow" data-id="element-4">
        <Hero data-id="element-5" />
        <CTA1 data-id="element-6" />
        <Testimonials1 data-id="element-7" />
        <PainSection data-id="element-8" />
        <ProductReveal data-id="element-9" />
        <TomosSection data-id="element-10" />
        <CTA2 data-id="element-11" />
        <BonosSection data-id="element-12" />
        <TestimonialsGrid data-id="element-13" />
        <CTA3 data-id="element-14" />
        <ComparisonTable data-id="element-15" />
        <Testimonials3 data-id="element-16" />
        <Guarantee data-id="element-17" />
        <FAQ data-id="element-18" />
        <CostTable data-id="element-19" />
        <CTA4 data-id="element-20" />
        <FinalClose data-id="element-21" />
      </main>

      <Footer data-id="element-22" />
    </div>;
}